const tabNameMap = {
  spiele: 'games',
  konto: 'myGameduell',
  help: 'infoAndHelp',
}
/**
 * maps the old tab names to the new tab names
 *
 * @param tabName home, games, myGameduell, community, infoAndHelp
 */
export default function mapTabName(oldTabName: string): string {
  return tabNameMap[oldTabName] || oldTabName
}
